import React, { useState } from 'react';
import styled from 'styled-components';
import { DropDown } from '@grays-npm/component-library';
import { useViewport } from '../../utils/viewport';
import { NativeDropDown } from '../DropDown';
import { useAuthData } from '../Auth';

const StyledDropDown = styled(DropDown)`
  margin: auto 0;
  z-index: 3;
  min-width: 0;
`;

export const VendorSelect: React.FC = () => {
  const { vendors, setCurrentVendor } = useAuthData();
  const [selectedVendor, setSelectedVendor] = useState(vendors[0].sellerId);

  const { isDesktop } = useViewport();

  const vendorOptions = vendors?.map(({ sellerId: value, name: label }) => ({
    value,
    label,
  }));

  const handleSelectVendor = (vendor: string) => {
    const newVendor = vendors?.find(({ sellerId }) => sellerId === vendor);
    if (newVendor) {
      setCurrentVendor(newVendor);
      setSelectedVendor(newVendor.sellerId);
    }
  };

  return vendorOptions ? (
    isDesktop ? (
      <StyledDropDown
        align="right"
        onChange={handleSelectVendor}
        options={vendorOptions}
        selectedValue={selectedVendor}
        maxWidth="400px"
      />
    ) : (
      <NativeDropDown onChange={handleSelectVendor} options={vendorOptions} />
    )
  ) : (
    <></>
  );
};
